<!-- 文件类型Column -->
<template>
    <div>
        <!-- //文件类型 0-Excel 1-pdf -->
      {{ row['file_type'] === 1 ? 'PDF' : 'Excel' }}
    </div>
</template>

<script>
export default {
    props: ['row'],
    data() {
        return {

        }
    }
}
</script>